import { InAppToWebDipState } from "./types";

export const initialState: InAppToWebDipState = {
	isChecking: true
};
